import { Grid, Typography } from "@mui/material";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyRound } from "../../../util/DoubleUtil";
import Button from "../../UI/Button";
import { Link } from 'react-router-dom';
const CantinaSaldoViewInsereCredito = ({ cantinaSaldo }) => {
    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Typography variant="h6">
                    Cantina Saldo
                </Typography>
            </Grid>
            <Grid size={12}>
                <p>Última Atualização: {dateTimeFormat(cantinaSaldo.dataHoraUltimaAtualizacao)}</p>
            </Grid>
            <Grid size={12}>
                <Grid container spacing={3}>
                    <Grid>
                        <p>Saldo: {currencyRound(cantinaSaldo.valorSaldo)}</p>
                    </Grid>
                    <Grid>
                        <Button
                            color='secondary'
                            component={Link}
                            to="/cantina/insere-credito"
                        >
                            Insere Crédito
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CantinaSaldoViewInsereCredito;